module.exports = __webpack_public_path__ + "icons/crossWhite.9d0e995ecf2083dad23bc7958bed0e14.svg";